import type {
  Brand,
  GetRequestsForInvoicingQuery,
  InvoicePaymentMethodFragment,
  Project,
  RequestForInvoicing,
  RequestForInvoicingStats,
} from "@src/__generated__/graphql";
import { map } from "lodash";

type TRequestForInvoicing = NonNullable<
  GetRequestsForInvoicingQuery["requestsForInvoicing"]
>["data"][0];

type TBrand = NonNullable<TRequestForInvoicing["brands"]>[0];
type TProjects = NonNullable<TRequestForInvoicing["projects"]>[0];

export class RequestForInvoicingModel {
  id: RequestForInvoicing["id"];
  ownerId?: string;
  status: RequestForInvoicing["status"];
  type: RequestForInvoicing["type"];
  brands: BrandModel[];
  stats: {
    total_amount: RequestForInvoicingStats["total_amount"];
    total_amount_with_vat: RequestForInvoicingStats["total_amount_with_vat"];
  };
  date_of_supply?: Date;
  created_at: Date;
  projects: ProjectsModel[];
  submitDate: RequestForInvoicing["submit_date"];
  note: RequestForInvoicing["note"];
  internal_note: RequestForInvoicing["internal_note"];
  invoicePaymentMethod?: InvoicePaymentMethodFragment | null;

  constructor(src: TRequestForInvoicing) {
    this.id = src.id;
    this.status = src.status;
    this.type = src.type;
    this.created_at = new Date(src.created_at);
    this.brands = map(src.brands, (b) => new BrandModel(b));
    this.stats = src.stats;
    this.date_of_supply = src.date_of_supply
      ? new Date(src.date_of_supply)
      : undefined;
    this.projects = map(src.projects, (p) => new ProjectsModel(p));
    this.ownerId = src.owner?.id;
    this.submitDate = src.submit_date;
    this.note = src.note;
    this.internal_note = src.internal_note;
    this.invoicePaymentMethod = src.invoicePaymentMethod ?? null;
  }
}

class BrandModel {
  id: Brand["id"];
  name: Brand["name"];
  constructor(src: TBrand) {
    this.name = src.name;
    this.id = src.id;
  }
}

class ProjectsModel {
  id: Project["id"];
  title: Project["title"];
  code: Project["code"];
  constructor(src: TProjects) {
    this.id = src.id;
    this.title = src.title;
    this.code = src.code;
  }
}
